// Angular Core
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function matchFieldsValidator(field1: string, field2: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fieldValue1 = control.get(field1)?.value;
    const fieldValue2 = control.get(field2)?.value;

    if (fieldValue1 && fieldValue2 && fieldValue1 !== fieldValue2) {
      return { fieldsMismatch: true };
    }

    return null;
  };
}
